/**
 * Formateo de fechas según el idioma activo.
 *
 * Sustituye a los `toLocaleDateString('es-ES')` dispersos: la fecha se muestra
 * con las convenciones del idioma (`10 de febrero de 2024`, `10 February 2024`,
 * `10 février 2024`, `10 de fevereiro de 2024`). Se fija la zona horaria de
 * Canarias/España peninsular (`Europe/Madrid`) para que una fecha ISO sin hora
 * (`2024-02-10`) muestre siempre el mismo día natural, sea cual sea la zona
 * horaria del navegador.
 */

import { DEFAULT_LANGUAGE } from './languages';

/** Localización de Intl para cada idioma soportado. */
const INTL_LOCALES = {
  es: 'es-ES',
  en: 'en-GB',
  fr: 'fr-FR',
  pt: 'pt-PT',
};

/**
 * @param {string} dateString - Fecha ISO (`2024-02-10`) o cualquier valor que acepte `Date`.
 * @param {string} language - Código de idioma de la aplicación (`es`, `en`, `fr`, `pt`).
 * @returns {string} Fecha legible en el idioma indicado (español si no se reconoce).
 */
export const formatDate = (dateString, language) => {
  const locale = INTL_LOCALES[language] || INTL_LOCALES[DEFAULT_LANGUAGE];
  return new Date(dateString).toLocaleDateString(locale, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'Europe/Madrid',
  });
};

export default formatDate;
